import { BodyText, DetailText } from 'design-configuration/components'
import { cn } from '@/lib/utils'

export function OnboardingStepFieldLabel({
  label,
  description,
  htmlFor,
  className
}: {
  label: string
  description: string
  htmlFor?: string
  className?: string
}): React.ReactNode {
  return (
    <label htmlFor={htmlFor} className={cn('block', className)}>
      <BodyText className="block font-medium" asChild>
        <span>{label}</span>
      </BodyText>
      <DetailText className="text-on-surface-variant block" asChild>
        <span>{description}</span>
      </DetailText>
    </label>
  )
}
